import Signal from "libs/signals";

const $systemUseNotification = Signal({
  show: true,
});

export default $systemUseNotification;
